export const refferallistDetails = [
  {
    Refferals_Image: "user-32.jpg",
    Refferals_ID: "Reff-001",
    Referrer_Name: "Anthony Lewis",
    Roll: "Finance",
    Job_Image: "apple.svg",
    Job_Reffered: "Senior IOS Developer",
    Refferee_Image: "user-11.jpg",
    Referee_Name: "Harold Gaynor",
    Email: "harold@example.com",
    Refferals_Bonus: "$200",
  },
  {
    Refferals_Image: "user-09.jpg",
    Refferals_ID: "Reff-002",
    Referrer_Name: "Brian Villalobos",
    Roll: "Developer",
    Job_Image: "php.svg",
    Job_Reffered: "Junior PHP Developer",
    Refferee_Image: "user-29.jpg",
    Referee_Name: "Sandra Ornellas",
    Email: "sandra@example.com",
    Refferals_Bonus: "$100",
  },
  {
    Refferals_Image: "user-01.jpg",
    Refferals_ID: "Reff-003",
    Referrer_Name: "Harvey Smith",
    Roll: "Developer",
    Job_Image: "black.svg",
    Job_Reffered: "Network Engineer",
    Refferee_Image: "user-16.jpg",
    Referee_Name: "John Harris",
    Email: "john@example.com",
    Refferals_Bonus: "$300",
  },
  {
    Refferals_Image: "user-33.jpg",
    Refferals_ID: "Reff-004",
    Referrer_Name: "Stephan Peralt",
    Roll: "Executive Officer",
    Job_Image: "react.svg",
    Job_Reffered: "Junior React Developer",
    Refferee_Image: "user-57.jpg",
    Referee_Name: "Whitney Barnette",
    Email: "whitney@example.com",
    Refferals_Bonus: "$150",
  },
  {
    Refferals_Image: "user-56.jpg",
    Refferals_ID: "Reff-005",
    Referrer_Name: "Doglas Martini",
    Roll: "Manager",
    Job_Image: "laravel.svg",
    Job_Reffered: "Senior Laravel Developer",
    Refferee_Image: "user-55.jpg",
    Referee_Name: "Richard Thompson",
    Email: "richard@example.com",
    Refferals_Bonus: "$250",
  },
  {
    Refferals_Image: "user-34.jpg",
    Refferals_ID: "Reff-006",
    Referrer_Name: "Linda Ray",
    Roll: "Finance",
    Job_Image: "devops.svg",
    Job_Reffered: "DevOps Engineer",
    Refferee_Image: "user-45.jpg",
    Referee_Name: "Kerry Drake",
    Email: "kerry@example.com",
    Refferals_Bonus: "$400",
  },
  {
    Refferals_Image: "user-42.jpg",
    Refferals_ID: "Reff-007",
    Referrer_Name: "Elliot Murray",
    Roll: "Developer",
    Job_Image: "android.svg",
    Job_Reffered: "Junior Android Developer",
    Refferee_Image: "user-30.jpg",
    Referee_Name: "David Carmona",
    Email: "david@example.com",
    Refferals_Bonus: "$450",
  },
  {
    Refferals_Image: "user-38.jpg",
    Refferals_ID: "Reff-008",
    Referrer_Name: "Rebecca Smtih",
    Roll: "Executive",
    Job_Image: "html.svg",
    Job_Reffered: "Senior HTML Developer",
    Refferee_Image: "user-26.jpg",
    Referee_Name: "Margaret Soto",
    Email: "margaret@example.com",
    Refferals_Bonus: "$220",
  },
  {
    Refferals_Image: "user-52.jpg",
    Refferals_ID: "Reff-009",
    Referrer_Name: "Connie Waters",
    Roll: "Developer",
    Job_Image: "ui.svg",
    Job_Reffered: "Junior UI/UX Designer",
    Refferee_Image: "user-44.jpg",
    Referee_Name: "Jeffrey Thaler",
    Email: "jeffrey@example.com",
    Refferals_Bonus: "$180",
  },
  {
    Refferals_Image: "user-06.jpg",
    Refferals_ID: "Reff-010",
    Referrer_Name: "Lori Broaddus",
    Roll: "Finance",
    Job_Image: "grafic.svg",
    Job_Reffered: "Senior Graphic Designer",
    Refferee_Image: "user-10.jpg",
    Referee_Name: "Joyce Golston",
    Email: "joyce@example.com",
    Refferals_Bonus: "$250",
  },
];
